import ReactDOMServer from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { NOT_AVAILABLE } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";
import PieChartTooltip from "app/pages/app-intelligence/app-analysis/components/GenericGraph/components/PieChartTooltip";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";
import { SearchOverviewTexts } from "../../../../texts";

export const defaultEmptyPieData = [
    {
        data: [
            {
                color: colorsPalettes.carbon[50],
                id: "Default",
                name: NOT_AVAILABLE,
                isEmpty: true,
                total: 100,
                y: 100,
            },
        ],
    },
];
export const staticChartData = {
    branded: {
        color: colorsPalettes.blue[400],
        id: "branded",
        get name() {
            return translate(SearchOverviewTexts.distributionBranded);
        },
    },
    nonBranded: {
        color: colorsPalettes.blue[200],
        id: "nonBranded",
        get name() {
            return translate(SearchOverviewTexts.distributionNonBranded);
        },
    },
};
export const getPieChartConfig = (isConnected: boolean) => ({
    chart: {
        marginTop: 26,
        width: 80,
        animation: false,
        type: "pie",
        plotBackgroundColor: "transparent",
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        enabled: isConnected,
        followPointer: true,
        outside: true,
        headerFormat: ``,
        useHTML: true,
        ...tooltipContainerConfig().tooltip,
        pointFormatter() {
            const value = FORMATTERS.percentSign(this.y, DEFAULT_DECIMAL);

            return ReactDOMServer.renderToString(
                <PieChartTooltip
                    name={this.name}
                    color={this.color}
                    value={this?.isEmpty ? NOT_AVAILABLE : value}
                />,
            );
        },
    },
    plotOptions: {
        pie: {
            innerSize: "60%",
            center: [10, 10],
            animation: false,
            showInLegend: true,
            cursor: "pointer",
            borderWidth: 0,
            borderRadius: 0,
            states: {
                hover: {
                    halo: null,
                },
            },
            dataLabels: {
                enabled: false,
            },
            size: 80,
        },
        series: {
            enableMouseTracking: isConnected,
        },
    },
});
